var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-listado-contrato-firmas"}},[(!_vm.$vuetify.breakpoint.mobile)?[_c('desktop',{attrs:{"listadoFirmas":_vm.listadoFirmas}})]:[_c('mobile',{attrs:{"listadoFirmas":_vm.listadoFirmas}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }